import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 20c0-5 2.2-8.5 5-10M9.2 20c0-3.6 1.5-6.2 3.8-7.6M11.4 20c0-2 1-3.4 2.6-4.2" }, null, -1),
    _createElementVNode("rect", {
      width: "4.4",
      height: "8.2",
      x: "13.2",
      y: "3",
      rx: "2.2"
    }, null, -1),
    _createElementVNode("path", { d: "M15.4 11.2V20" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-uzi"}) } }